import React from "react";
import { useNavigate } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import { enqueueSnackbar } from "notistack";
import { usersLoginPost } from "../../../../libs/apis";
import { useModulesBackupStore, useRouterStore } from "../../../../libs/stores";
import { useWorkflowOneStore } from "../../../../components/workflow-one/components/add/store";
import { useWorkflowTwoStore } from "../../../../components/workflow-two/components/add/store";

const schemaReport = Yup.object({
  user: Yup.string()
    .min(3, "Too Short!")
    .max(30, "Too Long!")
    .required("El Usuario es requerido"),
  password: Yup.string()
    .min(3, "Too Short!")
    .max(50, "Too Long!")
    .required("El Password es requerido"),
}).required();

export interface UserI {
  user: string;
  password: string;
}

export const initialValues: UserI = {
  user: "",
  password: "",
};

export const useLoginForm = () => {
  const navigate = useNavigate();
  const [isProcessing, setProcessing] = React.useState(false);
  const [savingPost, setSavingPost] = React.useState(false);
  const setModules = useRouterStore((state) => state.setModules);
  const setModulesBackup = useModulesBackupStore((state) => state.setModulesBackup);
  const setProfileId = useRouterStore((state) => state.setProfileId);
  const setClientId = useRouterStore((state) => state.setClientId);
  const setClient = useRouterStore((state) => state.setClient);
  const setClientIdentification = useRouterStore((state) => state.setClientIdentification);
  const setTypeDashboardCode = useRouterStore((state) => state.setTypeDashboardCode);
  const setFullName = useRouterStore((state) => state.setFullName);
  const setFirstName = useRouterStore((state) => state.setFirstName);
  const setAvatar = useRouterStore((state) => state.setAvatar);
  const [continuo, setContinuo] = React.useState(false);
  const resetWfOne = useWorkflowOneStore((state) => state.onClear);
  const resetWfTwo = useWorkflowTwoStore((state) => state.onClear);
  
  React.useEffect(() => {
    if (continuo) {
      setContinuo(false);
      setProcessing(false);
      navigate("/dashboard", { replace: true });
    }
  }, [continuo]);
 
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    control,
    reset,
  } = useForm<UserI | any>({
    resolver: yupResolver<Yup.AnyObject>(schemaReport),
    defaultValues: initialValues,
  });

  const onSubmit = async (values: any) => {
    try {
      setProcessing(true);
      const { data: dataUser } = await usersLoginPost(values);

      if (!dataUser) return;

      localStorage.setItem(
        process.env.REACT_APP_TOKEN!,
        JSON.stringify(dataUser)
      );
      enqueueSnackbar(`Bienvenido ${dataUser.user.fullName}`, {
        variant: "success",
      });
      setModules(dataUser.user.modules);
      setModulesBackup(dataUser.user.modules);
      setProfileId(dataUser.user.profileId);
      setClientId(dataUser.user.clientId);
      setClient(dataUser.user.client);
      setClientIdentification(dataUser.user.clientIdentification);
      setAvatar(dataUser.user.avatar!);
      setFullName(dataUser.user.fullName);
      setFirstName(dataUser.user.firstName);
      setTypeDashboardCode(dataUser.user.typeDashboardCode);
      setProcessing(false);
      resetWfOne();
      resetWfTwo();
      reset(initialValues);
      setContinuo(true);
    //   setTimeout(() => {
    //     navigate("/", { replace: true });
    //   }, 1000);
    } catch (err: any) {
      setProcessing(false);
      enqueueSnackbar(err ?? "Error, comuníquese con Sistemas", {
        variant: "error",
      });
    }
  };

  return {
    register,
    handleSubmit,
    errors,
    setValue,
    isProcessing,
    savingPost,
    onSubmit,
    control,
    reset,
  };
};
